import { OnInit, Component, Optional } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'os-cancel-popup',
    templateUrl: './OSCancelPopup.component.html',
    styleUrls: ['./OSCancelPopup.component.css']
  })

  export class OSCancelPopupComponent implements OnInit {
    serviceUrl: any;
    acctRef: any;
    subs: Subscription;
    dummydata: any;
    ismobile: boolean = false;
    isAdaTheme: boolean = false;
    constructor (@Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog, private nxiRestService: NxiRestService, private contextService: IContextService,
                 private http: HttpClient, private translationService: PershingTranslationService,  @Optional() @Inject('AppSettings') appSettings: any) {
                  this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
                  if (appSettings.deviceType === 'mobile') {
                    this.ismobile = true;
                  }
                  if (appSettings.themeType && appSettings.themeType === 'ada') {
                    this.isAdaTheme = true;
                  }
                }
    ngOnInit() {
        this.serviceUrl = this.nxiRestService.serviceUrl ;
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
        let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
        this.acctRef = contextValue.hashValue;
      });
    }
    closeDialog() {
        this.dialog.closeAll();
    }
    cancelOrder() {
        // console.log('delUrl', this.serviceUrl + '/trading/equity/cancel');
        this.http.delete(this.serviceUrl + '/trading/equity/cancel').subscribe(
          data => {
            this.dummydata = data;
          }
        );
        this.dialog.closeAll();
    }
}
